import { Button, Icon, Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useHelpHotjarUrl } from '@hotjar/translations';

import type { Resource } from '../../types';

const ResourceRow = styled.div`
  display: flex;
  align-items: center;
  padding: ${tokens.spacer.x2} 0;
`;

const ResourceCopy = styled(Text)`
  margin: 0 ${tokens.spacer.x1pt5};
  flex: 1;
`;

const ResourcesBox = styled.div`
  ${ResourceRow}:not(:last-child) {
    border-bottom: 1px solid ${tokens.color.ui_border};
  }
`;

interface ResourcesProps {
  resources: Resource[];
}

export const Resources = ({ resources }: ResourcesProps): JSX.Element | null => {
  const { t } = useTranslation();
  const helpHotjarUrl = useHelpHotjarUrl();

  return resources.length ? (
    <ResourcesBox>
      {resources.map(({ copy, url, icon }) => {
        let parsedUrl = url;

        // update help.hotjar.com links with current language
        if (!parsedUrl?.includes('https://')) {
          parsedUrl = `${helpHotjarUrl}${parsedUrl}`;
        }

        return parsedUrl !== null ? (
          <ResourceRow key={copy.slice(-10)}>
            <Icon icon={icon} />
            <ResourceCopy as="span" textType="body1">
              {t(copy)}
            </ResourceCopy>
            <Button as="a" isExternal href={parsedUrl} kind="ghost_standout" icon="open_new_window">
              {t('integrations:details.view')}
            </Button>
          </ResourceRow>
        ) : null;
      })}
    </ResourcesBox>
  ) : null;
};
